import { FormControl } from '@mui/material';
import { DesktopTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

export interface TimeInputProps {
  name: string;
  placeholder: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  required?: boolean;
  error?: boolean;
  errorInfo?: string;
}

const TimeInput = ({
  name,
  placeholder,
  value,
  onChange,
  disabled = false,
  autoFocus = false,
  required = false,
  error = false,
  errorInfo,
}: TimeInputProps) => {
  return (
    <FormControl fullWidth required={required} error={error}>
      <DesktopTimePicker
        name={name}
        label={placeholder}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => onChange(newValue?.toDate() || null)}
        disabled={disabled}
        autoFocus={autoFocus}
        slotProps={{
          textField: {
            helperText: error && errorInfo,
          },
        }}
      />
    </FormControl>
  );
};

export default TimeInput;
